import { Component, Input, OnInit } from '@angular/core';
import { Helpers } from '../../../helpers/helpers';
import { RenaultUserDTO } from 'src/app/models/renault-user-dto';
import { RenaultPuntoapuntoLocalCampaignCardDTO } from 'src/app/models/renault-puntoapunto-local-campaign';
import { PuntoapuntoRoles } from 'src/app/helpers/enum';

@Component({
  selector: 'pap-local-campaign-card',
  templateUrl: './puntoapunto-local-campaign-card.component.html',
  styleUrls: ['./puntoapunto-local-campaign-card.component.scss']
})
export class PuntoapuntoLocalCampaignCardComponent implements OnInit {

  buttonAction: string = '';

  @Input() model: RenaultPuntoapuntoLocalCampaignCardDTO;
  @Input() user: RenaultUserDTO;

  isR2 = false;
  isR3 = false;
  isMotrio = false;

  constructor(private helper: Helpers) { }

  ngOnInit(): void {

    this.isR2 = this.model.Roles.some(x=>x == PuntoapuntoRoles.R2);
    this.isR3 = this.model.Roles.some(x=>x == PuntoapuntoRoles.R3);
    this.isMotrio = this.model.Roles.some(x=>x == PuntoapuntoRoles.Motrio);

    switch (this.model.IdCampaignMedia) {
      case 3:
        this.buttonAction = 'Realizar campaña';
        break;
      default:
        this.buttonAction = 'Configurar';
        break;
    }

  }

  ngAfterViewInit(): void {  
    this.helper.enableBsTooltips();
  }
  
}
